import { render, staticRenderFns } from "./TarjetaConsulta.vue?vue&type=template&id=5a01a7c9&scoped=true&"
import script from "./TarjetaConsulta.vue?vue&type=script&lang=js&"
export * from "./TarjetaConsulta.vue?vue&type=script&lang=js&"
import style0 from "./TarjetaConsulta.vue?vue&type=style&index=0&id=5a01a7c9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a01a7c9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib'
import { VImg } from 'vuetify/lib'
installComponents(component, {
  VIcon,
  VImg,
})
